export default __webpack_public_path__ + "static/O0299-2b22887d4753cbd6f2b37e7f59c0982c.png";